class WishlistRequestList extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.requestList = this.requestList.bind(this)
    this.listeners.add(this, 'click', this.requestList)
  }

  async requestList (e) {
    e.preventDefault()

    if (!this.token) {
      window.location.href = `/account/login?next=${encodeURIComponent(
        `${this.listUrl}/request`,
      )}`
      return
    }

    await window.BAO.wishlist.requestList(this.listId, this.token)

    window.location.reload()
  }

  get listId () {
    return this.dataset.listId
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get listUrl () {
    return `${window.theme.appSettings.proxyUrl}/lists/${this.listId}`
  }
}

customElements.define('wishlist-request-list', WishlistRequestList)
